import { render } from "./BaseButtonGroup.vue?vue&type=template&id=1b38f065&scoped=true"
const script = {}

import "./BaseButtonGroup.vue?vue&type=style&index=0&id=1b38f065&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b38f065"]])

export default __exports__